import { Component, computed, inject } from '@angular/core';
import { BrnDialogImports, BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { HlmDialogImports } from '@spartan-ng/helm/dialog';
import { Cartographie } from '../../../cartographie/models/cartographie.model';
import { HlmButtonImports } from '@spartan-ng/helm/button';

@Component({
  selector: 'app-dialog-verrouillage-offre-regionale',
  imports: [BrnDialogImports, HlmDialogImports, HlmButtonImports],
  templateUrl: './dialog-verrouillage-offre-regionale.component.html',
})
export class DialogVerrouillageOffreRegionaleComponent {
  readonly #dialogRef = inject<BrnDialogRef>(BrnDialogRef);
  readonly #dialogContext = injectBrnDialogContext<{ cartographie: Cartographie }>();
  readonly cartographie = computed(() => this.#dialogContext.cartographie);

  close() {
    this.#dialogRef.close();
  }
}
